module.exports = __webpack_public_path__ + "static/studio_02-f0f62203c70491d004d1c5f6233d7d89.jpg";